import React, {FC, useEffect} from 'react';

import classNames from 'classnames';
import {connect} from 'react-redux';

import {useFeatureWithAnalytics} from 'components/feature';
import {PRESCRIPTION_STATUS} from 'constants/success';
import {ApplicationStoreType} from 'desktop/store';

import {getIsAllItemsOfOrderUpdated} from 'libs/success/helpers/helpers';

import {ItemsType} from 'types/successPage';

import {SuccessPageBottomSection} from '../../components/successPageBottomSection/successPageBottomSection';
import {getPrescriptionStatus} from '../../selectorsV2/prescription';
import {fetchOrderedItems} from '../../store/actions/orderItems/orderItems';
import {
    getStatus,
    isOrderContainsSomeContactLenses,
} from '../../store/selectors/orderItems/orderItems';
import {getOrderItems} from '../../store/selectors/orderStatus/orderStatus';
import {getOrderId} from '../../store/selectors/selectors';

import {SuccessContacts} from '../contactsTYP/successContacts';

import s from './successRedesign.scss';

export type PropsType = {
    orderId: string;
    isOrderedItemsPending: boolean;
    skeleton: React.ReactNode;
    hasCartContactLenses: boolean;
    fetchItems: (incrementOrderId: string) => void;
    orderItems: ItemsType;
    originalStatus: string;
};

/**
 * Success redesign container
 */
export const SuccessRedesign: FC<PropsType> = ({
    fetchItems,
    hasCartContactLenses,
    isOrderedItemsPending,
    orderId,
    orderItems,
    originalStatus,
    skeleton,
}) => {
    useFeatureWithAnalytics('dTYPContacts', false, 'desktop');
    const shouldShowFooter = hasCartContactLenses
        ? getIsAllItemsOfOrderUpdated(orderItems) || originalStatus === PRESCRIPTION_STATUS.UPLOAD
        : true;

    useEffect(() => {
        if (orderId !== '') fetchItems(orderId);
    }, [fetchItems, orderId]);

    if (isOrderedItemsPending) return skeleton;

    return (
        <div className={s.wrapper}>
            <div className={classNames(s.container, s.mainSection)}>
                {hasCartContactLenses && <SuccessContacts />}
            </div>
            {shouldShowFooter && (
                <div className={classNames(s.container, s.bottomSection)}>
                    <SuccessPageBottomSection />
                </div>
            )}
        </div>
    );
};

/**
 * Map state to props
 * @param {ApplicationStoreType} store - redux store
 * @returns {PropsType} props
 */
const mapStateToProps = (store: ApplicationStoreType) => ({
    hasCartContactLenses: isOrderContainsSomeContactLenses(store),
    isOrderedItemsPending: getStatus(store) === 'pending',
    orderId: getOrderId(store),
    orderItems: getOrderItems(store),
    originalStatus: getPrescriptionStatus(store),
});

export const SuccessRedesignConnected = connect(mapStateToProps, {fetchItems: fetchOrderedItems})(
    SuccessRedesign,
);
